export default "__VITE_ASSET__Brg5iygC__"